import SidebarLayout from "@/components/Shared/SidebarLayout";
export default {
  name: "history",
  components: { SidebarLayout },
  data() {
    return {
      items: [
        {
          text: this.$t("sidebars.history.openOrders"),
          link: "/history/orders-history",
          icon: "$openOrdersHistory"
        },
        {
          text: this.$t("sidebars.history.profitLossLimit"),
          link: "/history/precondition-orders-history",
          icon: "$openOrdersHistory"
        },
        {
          text: this.$t("sidebars.history.transactions"),
          link: "/history/p2p-transactions",
          icon: "$transactionsHistory"
        },
        {
          text: this.$t("sidebars.history.otc"),
          link: "/history/transaction",
          icon: "$profitLossLimitHistory"
        }
      ]
    };
  }
};
